import React, { useState, useEffect }  from 'react'
import { Table,  Space } from 'antd'
import Main from '../../../cpn/Main';
import CostNodeDel from './CostNodeDel';    
import CostNodeAdd from './CostNodeAdd';
import CostNodeCheck from './CostNodeCheck';
import CostNodeCopyAdd from './CostNodeCopyAdd';
import { useFKspjdListQuery } from '../../../store/DianShangYeWuApi';
function CostNodeList() {
    const qy_id = JSON.parse(localStorage.getItem('jtg-caiwu_qy_id'))
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'))
    const yh_id = JSON.parse(localStorage.getItem('jtg-caiwu_yh_id'))
    const yh_name = JSON.parse(localStorage.getItem('jtg-caiwu_yh_name'))
    const {data, isSuccess} = useFKspjdListQuery({ddzc_spjd_qy_id:qy_id});  
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess && data.Status === 'success' && data.Result){            
            // 找出所有不同的ddzc_spjd_user_id并合并
            const mergedArr = [];
            const userMap = {};
            data.Result.forEach(item => {
                // 用ddzc_spjd_user_id去合并
                if (item.ddzc_spjd_user_id && !userMap[item.ddzc_spjd_user_id]) {
                    userMap[item.ddzc_spjd_user_id] = {
                        key: item.ddzc_spjd_user_id,
                        ddzc_spjd_user_id: item.ddzc_spjd_user_id,
                        ddzc_spjd_user_name: item.ddzc_spjd_user_name,
                        ddzc_spjd_name: item.ddzc_spjd_name,
                        ddzc_spjd_yh_id: item.ddzc_spjd_yh_id,
                        ddzc_spjd_yh_name: item.ddzc_spjd_yh_name,
                        yh_id: item.ddzc_spjd_yh_id,
                        yh_name: item.ddzc_spjd_yh_name,
                    }
                    mergedArr.push(userMap[item.ddzc_spjd_user_id])
                }
            })
            setList(mergedArr);
        }else{
            setList([]);
        }
    }, [data, isSuccess])
    const columns = [
        {
            title: '付款单操作员',
            dataIndex: 'ddzc_spjd_user_name',
            key: 'ddzc_spjd_user_name',
            width: 300, 
            render: (text, record) => <Space>
                <CostNodeCheck
                    user_id={record.ddzc_spjd_user_id}
                    user_name={record.ddzc_spjd_user_name}
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                    ddzc_spjd_user_id={record.ddzc_spjd_user_id}
                    ddzc_spjd_user_name={record.ddzc_spjd_user_name}
                />
            </Space>
        },
        {
            title: '操作',
            key: 'action',
            render: (text, record) => <Space size={20}>
                <CostNodeDel
                    ddzc_spjd_user_id={record.ddzc_spjd_user_id}                    
                />
                <CostNodeCopyAdd
                    ddzc_spjd_user_id={record.ddzc_spjd_user_id}  
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                />
            </Space>
        },
    ]
    return (
        <Main selectedKeys={['/CostNodeList']}>
            <CostNodeAdd  
                qy_id={qy_id}
                qy_name={qy_name}
                yh_id={yh_id}
                yh_name={yh_name}
            />
            <Table
                columns={columns}
                dataSource={list}
                style={{marginTop:'10px',width:'500px'}}
                className="custom-table"
                size='small'
                bordered
                rowKey="key"
            />
        </Main>
    )
}

export default CostNodeList